export const iconFontAwesomeTextformattingAlignRight = (
	<i className="fa-solid fa-align-right"></i>
);
